import { z } from "zod";
import { normalizeDiscoverySource } from "@/lib/discoverySource";

// Loose but safe phone matcher: digits, spaces, parens, dashes, leading +.
export const phoneRegex = /^[+\d\s()-]*$/;

export const contactSchema = z.object({
  name: z.string().trim().min(1, "Name is required").max(100),
  business: z.string().trim().min(1, "Business name is required").max(100),
  email: z.string().trim().email("Invalid email address").max(255),
  phone: z.string().trim().max(20).regex(phoneRegex, "Invalid phone number").optional().or(z.literal("")),
  message: z.string().trim().min(1, "Message is required").max(2000),
  selfReportedDiscoverySource: z.unknown().transform(normalizeDiscoverySource),
});

export type ContactFormValues = z.infer<typeof contactSchema>;
